/*
 * Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */
import { inject, Injectable, InjectionToken } from '@angular/core';
import { FirebaseOptions, initializeApp } from 'firebase/app';
import { getMessaging, getToken, MessagePayload, onMessage } from 'firebase/messaging';

/**
 * Firebase configuration of the host application, e.g.:
 * `{ provide: FIREBASE_OPTIONS, useValue: environment.deliwellFirebase }`
 */
export const FIREBASE_OPTIONS = new InjectionToken<FirebaseOptions>('FIREBASE_OPTIONS');

/**
 * Single point of dependency on the Firebase SDK: owns app initialization and
 * wraps every `firebase/*` call used by the workspace. No other file may
 * import from `firebase/*`.
 */
@Injectable({
  providedIn: 'root',
})
export class FirebaseFacade {
  private readonly app = initializeApp(inject(FIREBASE_OPTIONS));

  getMessagingToken(options: { vapidKey: string; serviceWorkerRegistration: ServiceWorkerRegistration }): Promise<string> {
    return getToken(getMessaging(this.app), options);
  }

  onForegroundMessage(callback: (payload: MessagePayload) => void): void {
    onMessage(getMessaging(this.app), callback);
  }
}
